import React from 'react';
import './styles/SideNav.css';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import Divider from '@material-ui/core/Divider';
import MenuIcon from '@material-ui/icons/Menu';
import { NavLink } from 'react-router-dom';
import * as routes from '../constants/routes';
import SignOutButton from './SignOut';
import Numbers from './Numbers';
const axios = require('axios');

const drawerWidth = 270;

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%'
  },
  appBar: {
    position: 'absolute',
    marginLeft: drawerWidth,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`
    }
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    [theme.breakpoints.up('md')]: {
      position: 'relative'
    }
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    backgroundColor: '#eee'
  },
  button: {
    width: '90%'
  }
});

class ResponsiveDrawer extends React.Component {
  state = {
    mobileOpen: false
  };

  handleDrawerToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
  };

  render() {
    {
      // console.log(this.props);
    }
    const { classes, theme } = this.props;

    const drawer = (
      <div id="sidenav">
        <div className={classes.toolbar} id="sidebar-logo">
          <img src={require('./images/check.svg')} height="35px" />
          <p>
            Smsfor
            <span style={{ color: '#2698a7' }}>.me</span>
          </p>
          <hr />
        </div>
        <div className="flex-column navbar">
          <NavLink to={routes.LANDING} activeClassName="active-link" exact>
            {/* <NavLink to={routes.LANDING} activeClassName="active-link" exact> */}
            <i className="material-icons">dashboard</i>
            <p>Home</p>
          </NavLink>
          <NavLink to={routes.NUMBERS} activeClassName="active-link" exact>
            <i className="material-icons">sms</i>
            <p>Verifications</p>
          </NavLink>
          <NavLink to={routes.RENT} activeClassName="active-link" exact>
            {/* <i class="material-icons">apps</i> */}
            <i className="material-icons">sd_card</i>
            <p>Your Numbers</p>
          </NavLink>
          <NavLink to={routes.ACCOUNT} activeClassName="active-link" exact>
            <i className="material-icons">settings</i>
            <p>Account</p>
          </NavLink>

          <br />
          <br />
          <br />
          <br />
          <SignOutButton style={{ justifySelf: 'flex-end' }} />
        </div>
      </div>
    );

    return (
      <div className="leftSideNav">
        <div className={classes.root}>
          <AppBar className={classes.appBar}>
            <Toolbar
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={this.handleDrawerToggle}
                className={classes.navIconHide}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="title" color="inherit" noWrap>
                {/* Responsive drawer */}
                <span>{this.props.name ? this.props.name : 'wololoo....'}</span>
              </Typography>
              <span id="balanceSpan">
                {/* {this.props.name === "Numbers Panel" ? <SmallLoading/> : null} */}
              </span>
            </Toolbar>
          </AppBar>
          <Hidden mdUp>
            <Drawer
              variant="temporary"
              anchor={theme.direction === 'rtl' ? 'right' : 'left'}
              open={this.state.mobileOpen}
              onClose={this.handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper
              }}
              ModalProps={{
                keepMounted: true // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden smDown implementation="css">
            <Drawer
              variant="permanent"
              open
              classes={{
                paper: classes.drawerPaper
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <main className={classes.content}>
            <div className={classes.toolbar} />
            {/* <Typography noWrap>
            {"You think water moves fast? You should see ice."}
          </Typography> */}
            {/* {console.log(this.props)} */}
            {this.props.page}
          </main>
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ResponsiveDrawer);
